import { isEmpty } from 'lodash';

// @ts-expect-error - src/data/subscription does not have TypeScript definitions yet
import { getNextSeatTier, MIN_SEAT_TIER, SUBSCRIPTION_PLAN } from 'src/data/subscription';
import type { ID } from 'src/lib/collection';
import { ROUTE_PARAMS, ROUTES } from 'src/routes';

import { getQueryParams } from './browser';

export interface RouteParams {
  [key: string]: string | number | boolean | undefined;
}

interface Location {
  pathname: string;
  search: string;
}

const formatParams = (params: RouteParams): string => {
  const searchParams = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value !== undefined) {
      searchParams.set(key, String(value));
    }
  });

  return searchParams.toString();
};

export const formatProjectCreateRoute = (projectType: string, params?: RouteParams): string => {
  const searchString = params && !isEmpty(params) ? `&${formatParams(params)}` : '';

  return `${ROUTES.PROJECTS}/${projectType}?${ROUTE_PARAMS.creation}${searchString}`;
};

export const formatRoute = (pathname: string, params?: RouteParams): string => {
  const searchString = params && !isEmpty(params) ? `?${formatParams(params)}` : '';
  return `${pathname}${searchString}`;
};

export const formatCurrentLocationWithParams = (
  location: Location,
  params: RouteParams
): string => {
  const currentParams = getQueryParams(location.search);
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value !== undefined) {
      currentParams[key] = String(value);
    }
  });
  return formatRoute(location.pathname, currentParams as RouteParams);
};

export const formatProjectRoute = (projectId: ID, params?: RouteParams): string => {
  return formatRoute(`${ROUTES.PROJECTS}/${projectId}`, params);
};

export const formatProjectsFolderRoute = (folderId?: ID, params?: RouteParams): string => {
  if (!folderId) {
    return ROUTES.PROJECTS;
  }

  return formatRoute(ROUTES.PROJECTS, { ...params, [ROUTE_PARAMS.folder]: folderId });
};

const pickSeatTier = (currentTier?: string, sameTier?: boolean): string => {
  if (currentTier) {
    return sameTier ? currentTier : getNextSeatTier(currentTier);
  }

  return MIN_SEAT_TIER;
};

export const formatCheckoutLink = (params?: RouteParams): string => {
  return formatRoute(ROUTES.CHECKOUT, params);
};

export const formatDataDrivenCheckoutLink = (currentTier?: string, sameTier?: boolean): string => {
  const params: RouteParams = {
    plan: SUBSCRIPTION_PLAN.dataDriven,
  };
  const tier = pickSeatTier(currentTier, sameTier);
  if (tier) {
    params.tier = tier;
  }

  return formatCheckoutLink(params);
};

export const formatBrandVoiceChildRoute = (brandVoiceId: ID, route: string): string =>
  `${ROUTES.BRAND_VOICE}/${brandVoiceId}${route}`;
